import { render, staticRenderFns } from "./FreightTableRouteValidities.vue?vue&type=template&id=d0e57bba&scoped=true"
import script from "./FreightTableRouteValidities.vue?vue&type=script&lang=js"
export * from "./FreightTableRouteValidities.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRouteValidities.vue?vue&type=style&index=0&id=d0e57bba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e57bba",
  null
  
)

export default component.exports